import { types, getParent } from 'mobx-state-tree';

export const FilterActions = types
  .model({})
  .views(self => ({
    get filtersAsTags() {
      const checkIfNotEqualToInitial = filter => {
        if (filter.childs) {
          return filter.childs.some(checkIfNotEqualToInitial);
        }
        if (Array.isArray(self[filter.key])) {
          return self[filter.key].length !== 0;
        }
        return self[filter.key] !== self.initialFilterValues[filter.key];
      };
      return self.scheme.reduce((acc, filter) => {
        if (checkIfNotEqualToInitial(filter)) {
          acc.push(filter.key);
        }
        return acc;
      }, []);
    },
  }))
  .actions(self => ({
    resetFilterValue(key) {
      const resetFilter = filter => {
        if (filter.childs) {
          filter.childs.forEach(resetFilter);
        }
        self[filter.key] = self.initialFilterValues[filter.key];
      };
      if (typeof key === 'string') {
        const canceledFilter = self.scheme.find(({ key: fKey }) => fKey === key);
        return resetFilter(canceledFilter);
      }
      self.scheme.forEach(resetFilter);
      return getParent(self).clearFilters();
    },
  }));
